import { OverlayView } from "@react-google-maps/api"
import { memo } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

const PulseMarker = styled.div`
    background-color: #fff;
    border: 2px solid #fff;
    position: relative;
    overflow: hidden;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    animation: ${({animationControlType}) => animationControlType !== "animate" && "pulse 2s infinite"}; /* Animasyonu ekler */
    transform: translate(-50%, -50%);

    .live-location {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
    }

    @keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0.5); /* Başlangıç boyutu ve opaklığı */
    }
    70% {
        box-shadow: 0 0 0 20px rgba(255, 0, 0, 0); /* Genişler ve opaklık kaybolur */
    }
    100% {
        box-shadow: 0 0 0 0 rgba(255, 0, 0, 0); /* Biter */
    }
    }
`

const MemoizedOverlayDetailsMap = memo(({ position, imageUrl, animationControlType }) =>{

    
  return(
      <OverlayView
        position={position}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      >
        <PulseMarker animationControlType={animationControlType}>
          <img src={imageUrl} alt="custom-marker" className="live-location" />
        </PulseMarker>
      </OverlayView>
    )
  })

  
  export default MemoizedOverlayDetailsMap